import React from 'react'
import Footer from './Footer'
import about from '../img/about.jpg'

const About = () => {
  return (
    <>



      <div className='container mt-1 bg-success p-2 d-flex justify-content-center align-items-center rounded-3' >
        <h2 className="text-center mb-1 text-white">About</h2>
      </div>



      <div className='sections'>

        <div className='sections2'>
          <img src={about} />
        </div>


        <div className='sections2'>

          <h1>Welcome Shanti Fertilizer  </h1>

          <p>Welcome to Shanti Fertilizer  a trusted name in the agricultural industry since 2007. Located in  Barabanki, we are dedicated to supporting farmers and agricultural businesses with high-quality fertilizers that enhance crop yield and promote sustainable farming practices.</p>
          <p>At Shanti Fertilizer Customer satisfaction is at the heart of everything we do. We believe in building long-term relationships with our clients by providing top-notch products and exceptional service. Our commitment to quality ensures that every product we offer meets the highest standards, helping farmers achieve their agricultural goals.</p>


        </div>


      </div>



      <Footer />

    </>
  )
}

export default About
